module.exports = __webpack_public_path__ + "media/images/f_logo_RGB-Blue_72-c22a4ee3.png";